import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

export function MapperUtils() {
    return {
        getMappedOrderData({ orders, salesChannel, workspaceId }) {
            return orders.map(order => {
                return {
                    _id: null,
                    id: uuidv4(),
                    channelOrderDate: moment(order?.paidAt).format('YYYY-MM-DD HH:mm:ss'),
                    prodName: order?.productOrder?.sellerProductName || '',
                    optionName: order?.productOrder?.sellerProductItemName || '',
                    unit: order?.productOrder?.shippingCount || 0,
                    receiver: order?.receiver?.name || '',
                    receiverContact1: order?.receiver?.receiverNumber ? order?.receiver?.receiverNumber : order?.receiver?.safeNumber ? order?.receiver?.safeNumber : '',
                    receiverContact2: order?.receiver?.safeNumber || '',
                    destination: order?.receiver?.addr1 || '',
                    destinationDetail: order?.receiver?.addr2 || '',
                    salesChannel: salesChannel || '',
                    orderNumber1: `${order?.orderId}-${order?.productOrder?.vendorItemId}`,
                    orderNumber2: `${order?.orderId}` || '',
                    channelProdCode: order?.productOrder?.productId || '',
                    channelOptionCode: order?.productOrder?.vendorItemId || '',
                    zipCode: order?.receiver?.postCode || '',
                    courier: '',
                    transportType: '판매자 배송',
                    deliveryMessage: order?.parcelPrintMessage || '',
                    waybillNumber: '',
                    price: order?.productOrder?.orderPrice || 0,
                    deliveryCharge: order?.shippingPrice || 0,
                    barcode: '',
                    prodCode: '',
                    optionCode: order?.productOrder?.externalVendorSkuCode || '',
                    releaseOptionCode: order?.productOrder?.externalVendorSkuCode || '',
                    managementMemo1: order?.orderer?.name || '',
                    managementMemo2: order?.orderer?.ordererNumber ? order?.orderer?.ordererNumber : order?.orderer?.safeNumber ? order?.orderer?.safeNumber : '',
                    managementMemo3: `${order?.shipmentBoxId}` || '',
                    managementMemo4: '',
                    managementMemo5: '',
                    managementMemo6: salesChannel || '',
                    managementMemo7: '',
                    managementMemo8: order?.productOrder?.orderPrice || '',
                    managementMemo9: order?.shippingPrice || '',
                    managementMemo10: '',
                    workspaceId: workspaceId
                }
            })
        }
    }
}